import axios from 'axios';

import {rootURL} from '../config';

export class CultureService {

  static set(culture: string): Promise<any> {
    return axios.get(`${rootURL}`, {params: {culture}}).then(res => res.data);
  }

}
